import { observable } from "mobx";
import LoginStoreAction from "./loginStore.actions";

class LoginStoreClass extends LoginStoreAction {
  @observable isUserLoggedIn = false;
  @observable isModalOpen = false;
  @observable authError = false;
  @observable loader = false;
  @observable authErrorMsg = "";
  @observable missingFieldsLogin = {};
  @observable currentView = "login";
  @observable socialLoader = false;
  @observable userId = "";

  // TODO remove once token gives new data
  @observable accessTokenData = {};
  @observable refreshTokenData = {};
  @observable account = {};

  isAuthenticated() {
    return this.isUserLoggedIn;
  }
}
// const LoginStore = new LoginStoreClass();
export default LoginStoreClass;



// WEBPACK FOOTER //
// ./src/stores/Login/index.js